export const Type = {
  REGISTER_CONFIRM: "registerConfirm",
};
